module.exports = __webpack_public_path__ + "static/media/KW.0c58306d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/KW.svg
// module id = 293
// module chunks = 0